import {environment} from '../../../../environments/environment';

export class BaseRestService {
  private readonly endpoint: string;

  constructor(key) {
    this.endpoint = environment.apiUrl
      .concat('/rest/api/', key ? (key + '/') : '');
  }

  getEndpoint(keys?: Array<string>) {
    return this.endpoint + (keys && keys.join('/') || '');
  }
}
